import { Link } from 'react-router-dom';
import { Phone, Mail, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    navigation: [
      { path: '/', label: 'Accueil' },
      { path: '/services', label: 'Services' },
      { path: '/about', label: 'Pourquoi 0to1 ?' },
      { path: '/testimonials', label: 'Témoignages' },
      { path: '/contact', label: 'Contact' },
    ],
    services: [
      { label: 'Lead Generation' },
      { label: 'Sales 360' },
      { label: 'Consulting Sales' },
    ],
  };

  return (
    <footer className="bg-[#ECFDF5] border-t border-gray-200" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_prospection-pro/artifacts/uhkpo8js_logo_0to1_V1.png" 
                alt="0to1 Logo" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-[#1E3A5F] font-semibold text-base leading-relaxed mb-6 max-w-md">
              Boostez votre croissance commerciale avec 0to1
            </p>
            <div className="flex flex-col gap-3">
              <a 
                href="tel:0658930595" 
                className="flex items-center gap-3 text-[#1E3A5F] font-semibold hover:text-[#10B981] transition-colors duration-200"
                data-testid="footer-phone"
              >
                <Phone size={18} />
                <span>06 58 93 05 95</span>
              </a>
              <a 
                href="mailto:jehan@0to1-agency.fr" 
                className="flex items-center gap-3 text-[#1E3A5F] font-semibold hover:text-[#10B981] transition-colors duration-200"
                data-testid="footer-email"
              >
                <Mail size={18} />
                <span>jehan@0to1-agency.fr</span>
              </a>
              <a 
                href="https://www.linkedin.com/in/jehan-druguet" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#1E3A5F] font-semibold hover:text-[#10B981] transition-colors duration-200"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#1A1A1A] font-semibold mb-6 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[#1E3A5F] font-semibold hover:text-[#10B981] transition-colors duration-200 text-sm"
                    data-testid={`footer-link-${link.path.replace('/', '') || 'home'}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#1A1A1A] font-semibold mb-6 text-sm uppercase tracking-wider">Services</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.services.map((service, index) => (
                <li key={index}>
                  <Link
                    to="/services"
                    className="text-[#1E3A5F] font-semibold hover:text-[#10B981] transition-colors duration-200 text-sm"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#9CA3AF] text-sm">
            © {currentYear} 0to1. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/legal" 
              className="text-[#9CA3AF] hover:text-[#10B981] transition-colors duration-200 text-sm"
              data-testid="footer-legal-link"
            >
              Mentions légales
            </Link>
            <Link 
              to="/privacy" 
              className="text-[#9CA3AF] hover:text-[#10B981] transition-colors duration-200 text-sm"
              data-testid="footer-privacy-link"
            >
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
